<template>
  <div class="typeInfo">
    <main-title :title="title">
      <div
        v-if="location_country !== 'RU' && location_country !== 'KZ' && location_country !== 'UA'"
        slot="top"
        class="city-area"
        @click="handleClick('city')"
      >
        <div class="choose-city">
          <i></i>
          <label v-if="_area.text">{{ _area.text }}</label>
          <label v-else class="select-txt">{{ $t("city.selectTxt") }}</label>
        </div>
      </div>
    </main-title>
    <div v-if="showTypeInfo" style="position:relative;padding-bottom:2.5rem">
      <div class="typeInfoContent">
        <type-card
          :key="idx"
          v-for="(item, idx) in typeCardArr"
          :title="item.title"
          :desc="item.desc"
          :type-id="item.key"
          :index="item.key"
          :is-checked="identity === item.key"
          :disabled="!!item.disabled"
          @choose="handleClick"
        ></type-card>
      </div>
      <div class="btn-wraper">
        <p class="text-link" v-show="!['EC', 'PR', 'ZA'].includes(location_country)">
          <span @click="showSite">{{ offline_offsite.title }}</span>
        </p>
        <input
          type="button"
          :value="$t('typeInfo.next_btn_desc')"
          :class="{ active: isCanSubmit }"
          :disabled="!isCanSubmit"
          @click="handleClick('submit')"
        />
        <offline-site ref="offlineSite" :config="offline_offsite"></offline-site>
      </div>
    </div>

    <div v-if="!showTypeInfo">
      <ul>
        <li class="otherCityTxt" v-for="(item, idx) in otherCityTextList" :key="idx" v-html="item"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { showDialog } from "../../tools/Tip";
import { SERVICE_PHONE, SUPPORT_COUNTRY } from "../../tools/constant";

import MainTitle from "../base/main-title";
import TypeCard from "../base/type-card";
import OfflineSite from "../base/offline-site";

const OTHER_CITY_ID = 12345678;

export default {
  created() {
    // RU 和 UA的角色和其他国家不一样
    this.ru_fleet_driver_ab_test();
  },
  mounted() {
    this.ab_text();
    this.initData();
    Omega.trackEvent("gd_driverRole_view_sw");
  },
  data() {
    return {
      areaId: "",
      // areaName: "",
      identity: "",
      identityInfo: { // 普通国家(包括俄罗斯系的KZ) (global国家除俄罗斯系都已迁移至typeInfoMx)
        3: {
          key: "3",
          title: this.$t("drivingPartner"),
          desc: this.$t("typeInfo.drivingPartner_desc"),
        },
        1: {
          key: "1",
          title: this.$t("driver"),
          desc: this.$t("typeInfo.driver_desc"),
        },
        2: {
          key: "2",
          title: this.$t("nonDrivingPartner"),
          desc: this.$t("typeInfo.nonDrivingPartner_desc"),
        },
        4: {
          key: "4",
          title: this.$t("Others_optimization_IE_Driver_NXxZ"),
          desc: this.$t("Others_optimization_Your_own_lQpB"),
        },
      },
      identityInfoRUFleetDriver: { // 俄罗斯系国家 (ru ua) (KZ除外)
        2: {
          key: "2",
          title: this.$t("Others_optimization_Fleet_ZBMe"),
          desc: this.$t("Others_optimization_Registered_as_zUXs")
        },
        3: {
          key: "3",
          title: this.$t("GDriver_optimization_SE_driver_BlRL"),
          desc: this.$t("GDriver_optimization_Become_a_IcRZ")
        },
        4: {
          key: "4",
          title: this.$t("Others_optimization_IE_driver_GoiN"),
          desc: this.$t("Others_optimization_Become_a_TZut")
        },
        11: {
          key: "11",
          title: this.$t("Others_optimization_Link_to_Bwqp"),
          desc: this.$t("Others_optimization_Connect_to_LYfT"),
        },
        12: {
          key: "12",
          title: this.$t("Others_optimization_Fleet_driver_sNPa"),
          desc: this.$t("Others_optimization_Rental_of_uUpd")
        }
      },
      showOffline: true,
      showTypeInfo: true,
      title: this.$t("typeInfo.title"),
    };
  },
  computed: {
    ...mapState(["_ticket", "_area", "_identity", "_product", "_uuid", "_mx_type_product_text", "_ru_se_driver_switch_test", "_ru_fleet_driver_role_divison_test"]),
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    offline_offsite() {
      return {
        title: this.location_country === 'AR' ? this.$t("GDriver_text2_If_you_oDZY") : this.$t("offlineOffice"),
        link: process.env.GET_OFFLINESITE,
      };
    },
    typeCardArr() {
      let i = this.identityInfo;
      if (this._product == 1) {
        //出租车业务线，只保留车主选择
        return [i[3]];
      }
      //俄罗斯 车头在最上,车主暂时不放开
      //@200927 俄罗斯开放车主角色
      //@201217 俄罗斯新增apollo实验来控制是否开启俄罗斯se司机入口
      if (this.location_country === "RU") {
        // @211201 俄罗斯流程优化 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=730210965
        // if (this._ru_se_driver_switch_test && this._ru_fleet_driver_role_divison_test) {
        //   return [i[11], i[12], i[3], i[4], i[2]];
        // } else if (this._ru_se_driver_switch_test) {
        //   return [i[1], i[3], i[4], i[2]];
        // } else if (this._ru_fleet_driver_role_divison_test) {
        //   return [i[11], i[12], i[4], i[2]];
        // } else {
        //   i[3].disabled = true;
        //   return [i[1], i[4], i[2]];
        // }
        // @20220128 _ru_se_driver_switch_test、_ru_fleet_driver_role_divison_test实验全量，前端代码下掉
        return [i[11], i[12], i[3], i[4], i[2]];
      }
      if (this.location_country === "UA") {
          // @20210707 乌克兰新增SE driver、去除IE driver
          // @20211021 乌克兰OB流程优化 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=687541058
          return [i[3], i[11], i[12], i[2]];
      }
      if (this.location_country === "KZ") {
          // i[3].disabled = true;
          // @20210428 哈萨克下掉IE角色
          return [i[1], i[2]];
      }
      //@20210218 厄瓜多尔车头暂不开放
      if (this.location_country === "EC") {
        return [i[3], i[1]];
      }
      // 3:车主 1:司机 2:车头
      return [i[3], i[1], i[2]];
    },
    isCanSubmit() {
      //@20200901 俄罗斯流程优化，去除角色页城市选择
      if (this.location_country === "RU" || this.location_country === "UA" || this.location_country === "KZ") {
        return !!this.identity;
      }
      return !!(this.areaId && this.identity);
    },
    otherCityTextList() {
      const arr = [
        this.$t("typeInfo.other_city_txt1"),
        this.$t("typeInfo.other_city_txt2"),
      ];
      let TEL = SERVICE_PHONE[this.location_country] || "";
      return arr.map((item) => {
        return item.replace(
          /\{tel\}/,
          `<a href=tel:${TEL} style="color:#FF7226">${TEL}</a>`
        );
      });
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    ab_text() {
      if (this._mx_type_product_text && this.location_country === "MX" && this._product == 2) {
        this.title = "¿Cómo quieres registrarte?";
        this.identityInfo[3].title = "Socio conductor";
        this.identityInfo[3].desc = "Para registrarte con un vehículo.";
        this.identityInfo[1].title = "Conductor";
        this.identityInfo[1].desc = "Para registrarte sin vehículo y conducir un auto registrado en DiDi por alguien más.";
        this.identityInfo[2].title = "Socio";
        this.identityInfo[2].desc = "Para registrar vehículos y que los maneje alguien más.";
      }
    },
    ru_fleet_driver_ab_test() {
      // if (this._ru_fleet_driver_role_divison_test || this.location_country === 'UA') {
      //   this.identityInfo = this.identityInfoRUFleetDriver;
      // }

      // @20220216 _ru_se_driver_switch_test、_ru_fleet_driver_role_divison_test实验全量，前端代码下掉
      if (['UA', 'RU'].includes(this.location_country)) {
        this.identityInfo = this.identityInfoRUFleetDriver;
      }
    },
    initData() {
      if (this._area.value) {
        this.areaId = this._area.value;
        // this.areaName = this._area.text;
        if (this._area.value === OTHER_CITY_ID) {
          this.title = "";
          this.showTypeInfo = false;
        }
      } else {
        this.getLocation();
      }
      this._identity && (this.identity = this._identity);

      // @20210428 哈萨克车头文案处理
      if (this.location_country === "KZ") {
        this.identityInfo[2].title = "Таксопарк (ТОО/ИП)";
        this.identityInfo[2].desc = "Вы можете создать таксопарк, но для этого нужно предоставить документы, подтверждение статус ТОО или ИП.";
      }
    },
    handleClick(tag, payload) {
      switch (tag) {
        case "city":
          this.$router.push({ name: "city" });
          break;
        case "identity":
          this.identity = payload;
          this.setState({
            _identity: this.identity,
          });
          try {
            Omega.trackEvent("gd_driverRole_btn_ck", "", {
              driver_role: this.identity,
            });
          } catch (e) {}
          break;
        case "submit":
          showDialog(this, {
            type: "confirm",
            content: this.$t("typeInfo.submit_tips").replace(
              /{role}/,
              this.identityInfo[this.identity].title
            ),
            icon: "cubeic-alert",
            confirmBtn: {
              text: this.$t("typeInfo.OK"),
            },
            cancelBtn: { text: this.$t("typeInfo.Back") },
            onConfirm: this.handleSubmit,
          });
        default:
          break;
      }
    },
    handleSubmit() {
      // 不提交信息,暂存在store中，在baseInfo页面中一起提交
      if (!this.isCanSubmit) return;
      try {
        Omega.trackEvent("gd_driverRoleSubmit_btn_ck", "", {
          driver_role: this.identity,
          ibt_crm_uid: this._uuid,
        });
        gtm({ 'event': 's5ObIdSelection',
          'Identity': this._identity,
           'error': 'false' })
      } catch (e) {}

      this.$router.replace({
        name: `baseInfo${SUPPORT_COUNTRY[this.location_country]||"Mx"}`,
      });
    },
    getLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (!up.get("lng")) {
        up.set("lng", lng);
        up.set("lat", lat);
      }
      post(process.env.GETCITY_URL, up)
        .then((data) => {
          this.areaId = data.value;
          // this.areaName = data.text;
          this.setState({
            _area: {
              text: data.text,
              value: data.value,
            },
            _open_type: data.open_type,
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getLocation() {
      let up = new URLSearchParams(location.search);
      let lng = up.get("lng");
      let lat = up.get("lat");
      if (lat && lng) {
        this.getLocateCity(lng, lat);
      } else {
        let that = this;
        /**
         *  获取经纬度信息
         *  position_option 获取经纬度信息的配置项
         *  getPositionSuccess 信息获取成功函数
         *  getPositionError 信息获取失败函数
         */
        var position_option = {
          enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
          maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
          timeout: 3000, //超时时间
        };
        navigator.geolocation.getCurrentPosition(
          getPositionSuccess,
          getPositionError,
          position_option
        );
        function getPositionSuccess(position) {
          // that.locationInfo.lng = position.coords.longitude;
          // that.locationInfo.lat = position.coords.latitude;
          that.getLocateCity(
            position.coords.longitude,
            position.coords.latitude
          );
        }
        function getPositionError(e) {
          console.log(e);
        }
      }
    },
  },
  components: {
    MainTitle,
    TypeCard,
    OfflineSite,
  },
};
</script>
<style lang="scss" scoped>
.typeInfo {
  .city-area {
    padding: 0.04rem;
    margin-bottom: 0.36rem;
    .choose-city {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.9rem;
      background: #fff;
      line-height: 0.9rem;
      padding: 0 0.44rem 0 0.32rem;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      label {
        font-size: 0.4rem;
      }
      .select-txt {
        font-size: 0.28rem;
        color: #999;
      }
      & > i {
        border: 7px solid transparent;
        border-top-color: #000;
        position: absolute;
        top: 50%;
        right: 0.2rem;
        transform: translateY(-25%);
      }
    }
  }
  .typeInfoContent {
    margin-bottom: 0.8rem;
  }
  .otherCityTxt {
    padding: 0 0.32rem;
    margin-bottom: 0.36rem;
    line-height: 1.3;
    font-size: 0.4rem;
  }
  .btn-wraper {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.43rem 0.31rem;
    input {
      width: 6.84rem;
      height: 1.06rem;
      font-size: 0.4rem;
      color: #999;
      text-align: center;
      background-color: #eee;
      border-radius: 0.06rem;
    }
    .active {
      color: #fff;
      background: linear-gradient(45deg, #ff5b1d, #ff7f41);
    }
  }
}
</style>
